import { entityStore, Measurements, getBinLevelMeasurementOverrides } from '~/utility/BinSentry-ui-utility';
import SirenParse from 'siren-parser';

import '../../common/bn-placeholder';
import { LitEntity, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';

class BinAvgConsumption extends LitEntity {
  constructor() {
    super();
    this.range = '14';
  }

  static get styles() {
    return sharedStyles;
  }

  static get properties() {
    return {
      consumption: { type: Number, attribute: false },
      range: { type: String },
      measurement: { type: Object, attribute: false },
    };
  }

  render() {
    if (this.loading || !this.measurement) {
      return html`<bn-placeholder></bn-placeholder>`;
    }
    if (typeof this.consumption !== 'number') {
      return html`unknown`;
    }
    const bulkDensity = this.getProperty('bulkDensity');
    const totalVolume = this.getProperty('volumes.fullTotal');
    return this.measurement.html({ volume: this.consumption, totalVolume, bulkDensity });
  }

  async _entityChanged(entity) {
    super._entityChanged(entity);
    const statsHref = this.getHref('https://api.binsentry.com/rel/bin-stat-latest');
    const { entity: statsEntity } = await entityStore.fetchWait(statsHref);
    const siren = SirenParse(statsEntity);
    this.consumption = siren && siren.properties && siren.properties.volume.avgConsumptionPerDay[this.range];
    this.measurement = Measurements.get('binLevel', await getBinLevelMeasurementOverrides(this.entity));
  }
}

window.customElements.define('bin-avg-consumption', BinAvgConsumption);
